import React, { useEffect, useState } from 'react';
import { Download, Save } from '@mui/icons-material';
import { Card, CardContent, Typography } from '@mui/material';
import Formulario from 'components/formulario';
import TituloConIcono from 'components/tituloConIcono';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPorURL } from 'store/actions/customAction';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import { useDispatch } from 'react-redux';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import 'styles/global.css';
import { functions } from 'constantes/functions';
import { declaracionesJuradas } from 'constantes/declaracionesjuradas';
import BuscadorTimeline from 'pages/Timeline/Timeline/BuscadorTimeline';

let idPlanDeMediosIntegrado = "";
function PlanDeMediosIntegradoPrueba({ src }) {
  const dispatch = useDispatch();
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
  const[planDeMediosIntegrado] = useState("planDeMediosIntegrado");
  const[mostrarFormularioPlanMedios, setMostrarFormularioPlanMedios] = useState(false);
  const[mensajePlanDeMedios, setMensajePlanDeMedios] = useState("");
  const [mostrarFlowChart, setMostrarFlowChart] = useState(false);
  const [eventoActual, setEventoActual] = useState({});
  const[generarReportes] = useState("generarReportes");

  useEffect( () => {
    obtenerVueltaDePartido();
  }, [])

  const obtenerVueltaDePartido = async () => {
    setcargandoSolicitud(true);

    let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: planDeMediosIntegrado, saveInStore: false, action: "listar", nombreDelMetodo: "listar", parametro: `vueltaDePartido`}));

    setcargandoSolicitud(false);

    if(respuesta?.error) return alertaPersonalizadaSwal(respuesta?.error?.message || "Inconvenientes para obtener información!",'')

    if(respuesta?.data?.length === 0 ) return alertaPersonalizadaSwal(respuesta?.error?.message || "Sin datos encontrados!",'')

    if(Number(respuesta?.data?.evento_id) === 1) setEventoActual({id: 1, name: "Primera vuelta"})
    else setEventoActual({id: 2, name: "Segunda Vuelta"})

    obtenerPlanDeMediosIntegrados()
  }

  const obtenerPlanDeMediosIntegrados = async () => {
    setcargandoSolicitud(true);
    const copiaDeCampos = Object.assign({}, elementosDelFormulario);

    ServiciosDelAPI[planDeMediosIntegrado].metodoDeBusqueda.clear();
    let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: planDeMediosIntegrado, saveInStore: false, action: "listar", nombreDelMetodo: "listar", parametro: `siExisteInconformidad`}));

    setcargandoSolicitud(false);

    listadoDeBotones.guardarDatos.label = "Guardar datos";
    idPlanDeMediosIntegrado = "";
    copiaDeCampos.conformeDelPlan.value = ""
    copiaDeCampos.motivoDeInconformidad.value = ""
    setMensajePlanDeMedios("");

    if(respuesta?.error) {
        setMostrarFormularioPlanMedios(false)
        obtenerEstadoPlanDeMedios();
        setElementosDelFormulario(copiaDeCampos);
        if(respuesta?.error?.message === "La decision tomada del plan de medios de su partido ya fue registrada") {
          listadoDeBotones.guardarDatos.disabled = true;
          copiaDeCampos.conformeDelPlan.disabled = true;
          copiaDeCampos.motivoDeInconformidad.disabled = true;
          setMensajePlanDeMedios("LA OPCIÓN TOMADA DEL PLAN DE MEDIOS DE SU PARTIDO YA FUE REGISTRADA");
          return setElementosDelFormulario(copiaDeCampos);
        }
        listadoDeBotones.guardarDatos.disabled = true;
        copiaDeCampos.conformeDelPlan.disabled = true;
        copiaDeCampos.motivoDeInconformidad.disabled = true;
        setMensajePlanDeMedios("NO SE PUDÓ OBTENER SI YA ACEPTO DE CONFORMIDAD EL PLAN DE MEDIOS");
        return alertaPersonalizadaSwal(respuesta?.error?.message || "",'')
    }

    if(respuesta?.data?.length === 0) {
      setMostrarFormularioPlanMedios(true)
      setElementosDelFormulario(copiaDeCampos)
    };
    obtenerEstadoPlanDeMedios()

  }
  const obtenerEstadoPlanDeMedios = async () => {
    setcargandoSolicitud(true);
    setMostrarFlowChart(false);
    ServiciosDelAPI[generarReportes].metodoDeBusqueda.clear();
    ServiciosDelAPI[generarReportes].metodoDeOrden.clear();

    const respuesta = await dispatch(obtenerRegistrosPorURL({ controller: generarReportes, saveInStore: false, nombreDelMetodo: "listar", parametro: "mostrarPlanDeMedios"}));
    setcargandoSolicitud(false);

    if(respuesta?.error) return alertaPersonalizadaSwal(respuesta?.error?.message || "¡No se pudó obtener la información si el plan de medios ya fue validado por el TSE!",'')
    if(!respuesta?.data) return alertaPersonalizadaSwal("¡El plan de medios integrado aún no ha sido validado por el TSE!",'')

    setMostrarFlowChart(true);
  }

  const manejadorConformePlanMedio = (value) => {
    const copiaDeElementos = Object.assign({}, elementosDelFormulario);
    if(Number(value) === 1) {
      copiaDeElementos.motivoDeInconformidad.value = ""
      copiaDeElementos.motivoDeInconformidad.showInputTextArea = false
      copiaDeElementos.motivoDeInconformidad.pattern = ""
    } else {
      copiaDeElementos.motivoDeInconformidad.value = ""
      copiaDeElementos.motivoDeInconformidad.showInputTextArea = true;
      copiaDeElementos.motivoDeInconformidad.pattern = "^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{10,255}$"
    }
    setElementosDelFormulario(copiaDeElementos);
  }

  const [elementosDelFormulario, setElementosDelFormulario] = React.useState({
    tituloDatosDelCanal:{
        idelement: "tituloDatosDelCanal", title:'Datos del formulario', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloDatosDelCanal", value: "", isError:false,
    },
    conformeDelPlan:{
      idelement: "conformeDelPlan", value: null, label: "¿Está conforme con el plan de medios integrado? *", isError:false, elementType:'radio', errorMessages:['Debe marcar una opción'], options : [ { value: 1, label: 'SI' }, { value: 2, label: 'NO' }], 'disabled':false, isRequired: true, handler: manejadorConformePlanMedio
    },
    motivoDeInconformidad:{
        idelement: "motivoDeInconformidad", value: "", label: `Detalle el motivo de la inconformidad`, pattern:"", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "motivoDeInconformidad", width: '100%', showInputTextArea: false
    },
    criteriosAceptacion: {
      idelement: "criteriosAceptacion", value: "", label: "", isError: false, elementType: 'checkbox', errorMessages: ['El campo es requerido'], options: [{value: 1 , label: "Acepto que he leído los criterios para la Elaboración del Plan de Medios"}], 'disabled': false, isRequired: true, showInputCheckox: true, listValues: [], handler: undefined, width: '50%', numberColumns: 1
    },
    acciones:{
        idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
    },
  });

  const guardarDatos = async (dataForm) => {
    setcargandoSolicitud(true);

    const { conformeDelPlan, motivoDeInconformidad } = dataForm;

    const datosAGuardar = { motivoRechazo: motivoDeInconformidad, aceptaPlan: Number(conformeDelPlan) === 1 ? 1 : 0 };
    let datosAEnviar = {};
    let respuesta = {};

    if(idPlanDeMediosIntegrado) {
        datosAEnviar = { controller: planDeMediosIntegrado, action: "editar", data: datosAGuardar, nombreDelMetodo: `editar/${idPlanDeMediosIntegrado}` };
        respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
    } else {
        datosAEnviar = { controller: planDeMediosIntegrado, action: "crear", data: datosAGuardar, nombreDelMetodo: "crear/aceptacionORechazoDePlanDeMedios" };
        respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
    }

    setcargandoSolicitud(false);
    if(respuesta?.error) return alertaPersonalizadaSwal(respuesta?.error?.message || "No se puedo guardar los datos, intente nuevamente!",'')

    alertaPersonalizadaSwal(respuesta?.data || "Datos guardados correctamente", "", "success")

    obtenerPlanDeMediosIntegrados()
  }

  const descargarLosCriterios = () => functions.descargarBase64EnPDF(declaracionesJuradas.criteriosDeAceptacionPlanMedios, "criterios_para_elaboracion_plan_de_medios.pdf")

  const [listadoDeBotones]= React.useState({
    "guardarDatos":{"label":"Guardar datos", "icon": <Save />, "callback":guardarDatos,"loading":false,"size":"medium",
            "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
            "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
            isCancel: false,
    },
    "verCriterios":{"label":"Descargar los criterios para la Elaboración del Plan de Medios", "icon": <Download />, "callback":descargarLosCriterios,"loading":false,"size":"medium",
            "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
            "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
            isCancel: true,
    },
  });

  return (
    <>
      {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
      <TituloConIcono title={`PLAN DE MEDIOS INTEGRADO` }  mostrarTiempo={false} mostrarBotones={false} />
      {mostrarFormularioPlanMedios ? (
        <Card>
          <CardContent>
              <Formulario
                  elements={elementosDelFormulario}
                  buttonList={listadoDeBotones}
              />
          </CardContent>
        </Card>
      ) : (<Typography variant='h4' style={{margin: "30px auto 20px auto", textAlign: "center", fontWeight: "bold"}} >{mensajePlanDeMedios || ""}</Typography>) }

      {mostrarFlowChart ? (
          <div className="containerGlobal">
            <BuscadorTimeline eventoActual={eventoActual} />
          </div>
      ) : null}
    </>
  );
}

export default PlanDeMediosIntegradoPrueba;